import React, { useEffect, useState, useRef } from "react";
import useHttp from "../../../hooks/use-http";
import numberToWords from "number-to-words";
import { toast } from "react-toastify";
import moment from "moment";
import Modal from "react-modal";
import SimpleMap from "../../../components/gmaps";

const PackingListForm = (props) => {
  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 10,
    },
    content: {
      backgroundColor: "#fff",
      padding: "20px",
      top: "20%",
      left: "25%",
      borderRadius: "5px",
      maxWidth: "800px",
      maxHeight: "auto",
      height: "400px",
      width: "100%",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  };

  const modalStyles2 = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 10,
    },
    content: {
      backgroundColor: "#fff",
      padding: "20px",
      top: "20%",
      left: "25%",
      borderRadius: "5px",
      maxWidth: "300px",
      maxHeight: "auto",
      height: "300px",
      width: "100%",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  };
  const frmRef = useRef({});
  const productRef = useRef({});
  const [productDetails, setProductDetails] = useState([]);
  const [close, setClose] = useState(false);

  const addressRef = useRef({});
  const [addressDetails, setAddressDetails] = useState([]);
  const [addressClose, setAddressClose] = useState(false);

  const refNumberRef = useRef({});
  const [rnClose, setRnClose] = useState(false);
  const [rnDetails, setRnDetails] = useState([]);

  const [customerlist, setcustomerlist] = useState([]);
  const [customerId, setcustomerId] = useState([]);
  const [commercialInvoiceId, setCommercialInvoiceId] = useState();
  const [commercialInvoiceList, setCommercialInvoiceList] = useState([]);
  const [profarmaInvoiceId, setprofarmaInvoiceId] = useState();
  const [dndId, setdndId] = useState();

  const currentDate = new Date().toISOString().slice(0, 10);

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const { sendRequest: getcustomer } = useHttp();

  useEffect(() => {
    getcustomer(
      {
        url: `/api/customer/?orgId=${localStorage.getItem("orgId")}`,
        //url: `/api/getEmps/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        //console.log("customer", data[0].name);
        setcustomerlist(data);
      }
    );
  }, [getcustomer]);

  const { sendRequest: getCommercialInvoiceData } = useHttp();

  const loadCommercialInvoiceData = (id) => {
    setcustomerId(id);
    getCommercialInvoiceData(
      {
        url: `/api/commercialInvoice/?customerId=${id}`,
      },
      (res) => {
        //console.log("loadCommercialInvoiceData", res);
        setCommercialInvoiceList(res);
      }
    );
  };

  const { sendRequest: getcommercialInvoiceProductData } = useHttp();

  const loadcommercialInvoiceData = (id) => {
    setCommercialInvoiceId(id);

    var itemfilter = commercialInvoiceList.filter(
      (item) => item.commercialInvoiceId == id
    );
    var item = itemfilter[0];
    if (item) {
      frmRef.current.bill_of_lading.value = item.billOfLoading;
      setAddressDetails(item.buyerDetails);
      frmRef.current.reference_numbers = item.referenceNo;
      frmRef.current.method_of_dispatch.value = item.methodOfDispatch;
      frmRef.current.type_of_shipment.value = item.typeOfShipment;
      frmRef.current.country_origin.value = item.countryOfOriginOfGoods;
      frmRef.current.country_final_destination.value =
        item.countryOfFinalDestination;
      frmRef.current.vessel_name.value = item.vesselAircraftName;
      frmRef.current.voyage_number.value = item.voyageNo;

      frmRef.current.port_of_loading.value = item.portOfLoading;
      //frmRef.current.departure_date.value=item.dateOfDeparture//moment(item.dateOfDeparture).format("YYYY-MM-DD");
      frmRef.current.port_discharge.value = item.portOfDischarge;
      frmRef.current.final_destination.value = item.finalDestination;
      setprofarmaInvoiceId(item.profarmaInvoiceId);

      frmRef.current.name_of_authorized_signatory.value =
        item.nameOfAuthorizedSignatory;
      frmRef.current.place_of_issue.value = item.placeOfIssue;
      frmRef.current.remark.value = item.remark;

      getcommercialInvoiceProductData(
        {
          url: `/api/DeliveryNDispatchForEximDoc/?salesOrderId=${
            item.salesOrderId
          }&orgId=${localStorage.getItem("orgId")}`,
        },
        (res) => {
          setProductDetails(res.DeliveryDispatch[0].dndProductDetails);

          frmRef.current.currency.value = res.DeliveryDispatch[0].currencyCode;
          setdndId(res.DeliveryDispatch[0].dndId);

          var i = 0;
          do {
            res.DeliveryDispatch[0].dndProductDetails[i]["measurements"] = "";
            res.DeliveryDispatch[0].dndProductDetails[i]["MarksNumber"] = "";
            res.DeliveryDispatch[0].dndProductDetails[i]["KindNoOfPackages"] =
              "";

            i++;
          } while (res.DeliveryDispatch[0].dndProductDetails.length > i);

          //console.log(
          //   "deliveryNDispatch afetr",
          //   res.DeliveryDispatch[0].dndProductDetails
          // );
        }
      );
    }
  };

  const { sendRequest: postPackingList } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();
    const data = {
      customsPackingDate: moment(frmRef.current.pdate.value).format(
        "DD/MM/YYYY"
      ),
      customerName: frmRef.current.customer_name.value,
      customerId: customerId,
      profarmaInvoiceId: profarmaInvoiceId,
      commercialInvoiceId: commercialInvoiceId,
      dndId: dndId,
      billOfLoading: frmRef.current.bill_of_lading.value,
      buyerDetails: addressDetails,
      referenceNo: rnDetails,
      commercialInvoiceId: commercialInvoiceId,
      methodOfDispatch: frmRef.current.method_of_dispatch.value,
      typeOfShipment: frmRef.current.type_of_shipment.value,
      countryOfOriginofGoods: frmRef.current.country_origin.value,
      countryofFinalDestination: frmRef.current.country_final_destination.value,
      vesselAircreftName: frmRef.current.vessel_name.value,
      voyageNo: frmRef.current.voyage_number.value,
      portOfLoading: frmRef.current.port_of_loading.value,
      dateOfDeparture: moment(frmRef.current.departure_date.value).format(
        "DD/MM/YYYY"
      ),
      portOfDischarge: frmRef.current.port_discharge.value,
      finalDestination: frmRef.current.final_destination.value,
      PackingInformation: frmRef.current.packing_information.value,
      productDetails: productDetails,
      nameOfAuthorizedSignatory:
        frmRef.current.name_of_authorized_signatory.value,
      placeOfIssue: frmRef.current.place_of_issue.value,
      remark: frmRef.current.remark.value,
      createdBy: parseInt(localStorage.getItem("id")),
      orgId: localStorage.getItem("orgId"),
      status: 1,
      warehouseId: localStorage.getItem("warehouseId"),
    };
    //console.log(data);
    if (props.update) {
      data["packingListId"] = props.update.packingListId;
    }
    postPackingList(
      {
        url: "/api/packingList/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (data) => {
        //console.log(data);
        toast.success(
          `Customs Packing List ${props.update ? "Updated" : "Added"}`
        );
        props.addForm(false);
      }
    );
  };

  useEffect(() => {
    //console.log(props.update);
    if (props.update) {
      frmRef.current.pdate.value = moment(props.update.Date).format(
        "YYYY-MM-DD"
      );
      frmRef.current.customer_name.value = props.update.customerName;
      setcustomerId(props.update.customerId);

      frmRef.current.bill_of_lading.value = props.update.billOfLoading;
      setAddressDetails(props.update.buyerDetails);
      frmRef.current.reference_numbers = props.update.referenceNo;
      setCommercialInvoiceId(props.update.commercialInvoiceId);
      frmRef.current.method_of_dispatch.value = props.update.methodOfDispatch;
      frmRef.current.type_of_shipment.value = props.update.typeOfShipment;
      frmRef.current.country_origin.value = props.update.countryOfOriginofGoods;
      frmRef.current.country_final_destination.value =
        props.update.countryofFinalDestination;
      frmRef.current.vessel_name.value = props.update.vesselAircreftName;
      frmRef.current.voyage_number.value = props.update.voyageNo;

      frmRef.current.port_of_loading.value = props.update.portOfLoading;
      frmRef.current.departure_date.value = props.update.dateOfDeparture;
      frmRef.current.port_discharge.value = props.update.portOfDischarge;
      frmRef.current.final_destination.value = props.update.finalDestination;
      frmRef.current.packing_information.value =
        props.update.PackingInformation;

      setProductDetails(props.update.productDetails);
      frmRef.current.name_of_authorized_signatory.value =
        props.update.nameOfAuthorizedSignatory;
      frmRef.current.place_of_issue.value = props.update.placeOfIssue;
      frmRef.current.remark.value = props.update.remark;
    }
  }, [props.update]);
  const submitProduct = (e) => {
    e.preventDefault();
    setProductDetails((x) => [
      ...x,
      {
        srno:
          productDetails.length > 0
            ? productDetails[productDetails.length - 1].srno + 1
            : 1,
        itemId: productRef.current.itemId.value,
        noOfPackages: productRef.current.no_of_packages.value,
        itemDescription: productRef.current.itemDescription.value,
        netWeight: productRef.current.net_weight.value,
        grossWeight: productRef.current.gross_weight.value,
        unitQuantity: productRef.current.unit_quantity.value,
        measurements: productRef.current.measurements.value,
      },
    ]);

    //console.log(productDetails);
  };
  const handleDelete = (index, e) => {
    setProductDetails(productDetails.filter((v, i) => i !== index));
  };
  const submitAddress = (e) => {
    e.preventDefault();
    setAddressDetails((x) => [
      ...x,
      {
        srno:
          addressDetails.length > 0
            ? addressDetails[addressDetails.length - 1].srno + 1
            : 1,
        partyType: addressRef.current.party_type.value,
        name: addressRef.current.name.value,
        email: addressRef.current.email.value,
        contactNumber: addressRef.current.contact_number.value,
        contactPersonName: addressRef.current.contact_person_name.value,
        landmark: addressRef.current.landmark.value,
        city: addressRef.current.city.value,
        state: addressRef.current.state.value,
        zipcode: addressRef.current.zipcode.value,
        country: addressRef.current.country.value,
      },
    ]);
    //console.log(addressDetails);
  };
  const handleAddressDelete = (index, e) => {
    setAddressDetails(addressDetails.filter((v, i) => i !== index));
  };

  const submitRefNum = (e) => {
    e.preventDefault();
    setRnDetails([
      {
        shipperReferenceNumber: refNumberRef.current.shipp_ref_number.value,
        buyerReferenceNumber: refNumberRef.current.buy_ref_number.value,
        isSave: true,
      },
    ]);

    //console.log(rnDetails);
    setRnClose(false);
  };
  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="card card-default">
              <form onSubmit={submitHandler}>
                <div className="card-header">
                  <h3 className="card-title">Customs Packing List Form</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"pate"}>{"Date "}</label>
                      <input
                        type={"date"}
                        id={"pdate"}
                        required
                        ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedDate}
                        onChange={handleDateChange}
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"customer_name"}>{"Customer Name"}</label>
                      <select
                        id="customer_name"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["customer_name"] = el)}
                        value={customerId}
                        onChange={(e) => {
                          loadCommercialInvoiceData(e.target.value);
                        }}
                      >
                        <option>Select</option>
                        {customerlist &&
                          customerlist.map((x) => (
                            <option
                              key={x.customerId}
                              Customer-id={x.customerId}
                              value={x.customerId}
                            >
                              {x.name + "(" + x.customerCode + ")"}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"commercial_invoice_number"}>
                        {"Commercial Invoice id/Number"}
                      </label>

                      <select
                        id="commercialInvoiceId"
                        className="form-control dropdowns"
                        ref={(el) =>
                          (frmRef.current["commercialInvoiceId"] = el)
                        }
                        value={commercialInvoiceId}
                        onChange={(e) => {
                          setCommercialInvoiceId(e.target.value);
                          loadcommercialInvoiceData(e.target.value);
                        }}
                      >
                        <option value="0">Select</option>
                        {commercialInvoiceList &&
                          commercialInvoiceList.map((x) => (
                            <option
                              key={x.commercialInvoiceId}
                              value={x.commercialInvoiceId}
                            >
                              {x.commercialInvoiceNo}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"bill_of_lading"}>
                        {"Bill of Lading/Airway Bill No"}
                      </label>
                      <input
                        type={"text"}
                        id={"bill_of_lading"}
                        required
                        ref={(el) => (frmRef.current["bill_of_lading"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"buyer_details"}>
                        {"Buyer Details(if not Consignee) "}
                      </label>
                      <br />
                      &nbsp;&nbsp;
                      <button
                        type={"button"}
                        ref={(el) => (frmRef.current["buyer_details"] = el)}
                        className="btn btn-sm btn-warning"
                        onClick={() => {
                          addressDetails &&
                            setAddressDetails((items) =>
                              items.filter((x) => x.isSave)
                            );
                          setAddressClose(true);
                        }}
                      >
                        Add
                      </button>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"reference_numbers"}>
                        {"Reference Numbers"}
                      </label>
                      <br />
                      &nbsp;&nbsp;
                      <button
                        type={"button"}
                        ref={(el) => (frmRef.current["reference_numbers"] = el)}
                        className="btn btn-sm btn-info"
                        onClick={() => {
                          setRnClose(true);
                        }}
                      >
                        Add
                      </button>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"country_origin"}>
                        {"Country of Origin of Goods"}
                      </label>
                      <input
                        type={"text"}
                        id={"country_origin"}
                        required
                        ref={(el) => (frmRef.current["country_origin"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"method_of_dispatch"}>
                        {"Method  of Dispatch"}
                      </label>
                      <select
                        id="method_of_dispatch"
                        className="form-control dropdowns"
                        ref={(el) =>
                          (frmRef.current["method_of_dispatch"] = el)
                        }
                      >
                        <option value="Land">Land</option>
                        <option value="Sea">Sea</option>
                        <option value="Air">Air</option>
                      </select>
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"type_of_shipment"}>
                        {"Type of Shipment"}
                      </label>
                      <select
                        id="type_of_shipment"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["type_of_shipment"] = el)}
                      >
                        <option value="Full Container Load(FCL)">
                          Full Container Load(FCL)
                        </option>
                        <option value="Less than Container Load(LCL)">
                          Less than Container Load(LCL)
                        </option>
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"voyage_number"}>
                        {" "}
                        {"Voyage Number"}
                      </label>
                      <input
                        type={"text"}
                        id={"voyage_number"}
                        required
                        ref={(el) => (frmRef.current["voyage_number"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"country_final_destination"}>
                        {"Country of Final Destination"}
                      </label>
                      <input
                        type={"text"}
                        id={"country_final_destination"}
                        required
                        ref={(el) =>
                          (frmRef.current["country_final_destination"] = el)
                        }
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"vessel_name"}>
                        {"Vessel/Aircraft Name"}
                      </label>
                      <input
                        type={"text"}
                        id={"vessel_name"}
                        required
                        ref={(el) => (frmRef.current["vessel_name"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"port_discharge"}>
                        {" "}
                        {"Port of Discharge"}
                      </label>
                      <input
                        type={"text"}
                        id={"port_discharge"}
                        required
                        ref={(el) => (frmRef.current["port_discharge"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"port_of_loading"}>
                        {"Port of Loading"}
                      </label>
                      <input
                        type={"text"}
                        id={"port_of_loading"}
                        required
                        ref={(el) => (frmRef.current["port_of_loading"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"departure_date"}>
                        {"Date of Departure"}
                      </label>
                      <input
                        type={"date"}
                        id={"departure_date"}
                        required
                        ref={(el) => (frmRef.current["departure_date"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"product_details"}>
                        {"Product Details"}
                      </label>
                      <br />
                      <button
                        type={"button"}
                        className="btn btn-sm btn-success"
                        onClick={() => {
                          productDetails && setClose(true);
                        }}
                      >
                        Add
                      </button>
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"final_destination"}>
                        {" "}
                        {"Final Destination"}
                      </label>
                      <input
                        type={"text"}
                        id={"final_destination"}
                        required
                        ref={(el) => (frmRef.current["final_destination"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"packing_information"}>
                        {"Packing Information"}
                      </label>
                      <input
                        type={"text"}
                        id={"packing_information"}
                        required
                        ref={(el) =>
                          (frmRef.current["packing_information"] = el)
                        }
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"name_of_authorized_signatory"}>
                        {"Name of Authorized Signatory"}
                      </label>
                      <input
                        type={"text"}
                        id={"name_of_authorized_signatory"}
                        required
                        ref={(el) =>
                          (frmRef.current["name_of_authorized_signatory"] = el)
                        }
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"place_of_issue"}>
                        {"Place of Issue"}
                      </label>
                      <input
                        type={"text"}
                        id={"place_of_issue"}
                        required
                        ref={(el) => (frmRef.current["place_of_issue"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"remark"}>{"Remark/Note"}</label>
                      <input
                        type={"text"}
                        id={"remark"}
                        required
                        ref={(el) => (frmRef.current["remark"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className=" text-right">
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
      {/* address modal */}
      {addressClose && (
        <Modal isOpen={true} style={modalStyles}>
          <div className="">
            <h3 className="card-title">
              {" "}
              Forwarding Agent/Notify Party Details
            </h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setAddressClose(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-md-3">
              <label htmlFor={"party_type"}>{"Party Type"}</label>
              <select
                className="form-control"
                ref={(el) => (addressRef.current["party_type"] = el)}
                autoComplete="off"
              >
                <option>Forwarding Agent</option>
                <option>Notify Party</option>
                <option>Additional Notify Party</option>
              </select>
            </div>
            <div className="col-md-3">
              <label htmlFor={"name"}>Name</label>
              <input
                type={"input"}
                id={"name"}
                required
                ref={(el) => (addressRef.current["name"] = el)}
                className="form-control"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"email"}>Email id</label>
              <input
                type={"input"}
                id={"email"}
                required
                ref={(el) => (addressRef.current["email"] = el)}
                className="form-control"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"contact_person_name"}>contact Person Name</label>
              <input
                type={"input"}
                id={"contact_person_name"}
                required
                ref={(el) => (addressRef.current["contact_person_name"] = el)}
                className="form-control"
              />
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-md-3">
              <label htmlFor={"contact_number"}>Contact Number</label>
              <input
                type={"input"}
                id={"contact_number"}
                required
                ref={(el) => (addressRef.current["contact_number"] = el)}
                className="form-control"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"landmark"}>Address(landmark)</label>
              <input
                type={"input"}
                id={"landmark"}
                required
                ref={(el) => (addressRef.current["landmark"] = el)}
                className="form-control"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"city"}>City</label>
              <input
                type={"input"}
                id={"city"}
                required
                ref={(el) => (addressRef.current["city"] = el)}
                className="form-control"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"state"}>State</label>
              <input
                type={"input"}
                id={"state"}
                required
                ref={(el) => (addressRef.current["state"] = el)}
                className="form-control"
              />
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-md-3">
              <label htmlFor={"zipcode"}>Zip Code</label>
              <input
                type={"text"}
                id={"zipcode"}
                required
                ref={(el) => (addressRef.current["zipcode"] = el)}
                className="form-control"
              />
            </div>

            <div className="col-md-3">
              <label htmlFor={"country"}>Country</label>
              <input
                type={"text"}
                id={"country"}
                required
                ref={(el) => (addressRef.current["country"] = el)}
                className="form-control"
              />
            </div>
            <div className="col-md-3">
              <br />
              <button
                className="btn-sm btn btn-secondary"
                onClick={submitAddress}
              >
                +
              </button>
            </div>
          </div>

          <hr />

          <table className="table table-sm table-bordered table-responsive ">
            {" "}
            <thead>
              <tr>
                <th>Sr. No</th>
                <th>Party Type</th>
                <th>Name</th>
                <th>Email</th>
                <th>contact Person Name</th>
                <th>Contact Number</th>
                <th>Address(landmark)</th>
                <th>City</th>
                <th>State/Province/region</th>
                <th>Zip Code</th>
                <th>Country</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              {addressDetails &&
                addressDetails.map((itm, i) => {
                  return (
                    <tr key={i}>
                      <td>{itm.srno}</td>
                      <td>{itm.partyType}</td>
                      <td>{itm.name}</td>
                      <td>{itm.email}</td>
                      <td>{itm.contactPersonName}</td>
                      <td>{itm.contactNumber}</td>
                      <td>{itm.landmark}</td>
                      <td>{itm.city}</td>
                      <td>{itm.state}</td>
                      <td>{itm.zipcode}</td>
                      <td>{itm.country}</td>

                      <td>
                        {" "}
                        <button
                          className="btn"
                          onClick={(e) => handleAddressDelete(i, e)}
                        >
                          <i className="fa fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>

          <div className="text-center">
            <button
              className="btn btn-sm btn-primary"
              onClick={() => {
                addressDetails.map((x) => (x["isSave"] = true));
                setAddressClose(false);
              }}
            >
              Save
            </button>
          </div>
        </Modal>
      )}
      {/* end address modal */}
      {/*reference_numbers modal */}
      {rnClose && (
        <Modal isOpen={true} style={modalStyles2}>
          <div className="">
            <div className="">
              <h3 className="card-title">Reference Numbers Details</h3>
              <div className="card-tools text-right">
                <button
                  type="button"
                  className="btn btn-tool"
                  data-card-widget="remove"
                  onClick={() => setRnClose(false)}
                >
                  <i className="fas fa-times" />
                </button>
                <hr />
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-md-12">
                <label htmlFor={"shipp_ref_number"}>
                  Shipper Reference No{" "}
                </label>
                <input
                  type={"input"}
                  id={"shipp_ref_number"}
                  required
                  ref={(el) => (refNumberRef.current["shipp_ref_number"] = el)}
                  className="form-control"
                />
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-md-12">
                <label htmlFor={"buy_ref_number"}>Buyer Reference No</label>
                <input
                  type={"input"}
                  id={"buy_ref_number"}
                  required
                  ref={(el) => (refNumberRef.current["buy_ref_number"] = el)}
                  className="form-control"
                />
              </div>
            </div>

            <div className="text-center">
              <button className="btn btn-sm btn-primary" onClick={submitRefNum}>
                Save
              </button>
            </div>
          </div>
        </Modal>
      )}

      {close && (
        <Modal isOpen={true} style={modalStyles}>
          <div className="">
            <h3 className="card-title"> Product Details</h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setClose(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
          </div>

          <hr />

          <table className="table table-sm table-bordered">
            {" "}
            <thead>
              <tr>
                <th>Sr. No</th>
                <th>Item Id</th>
                <th>Product Name</th>
                <th>Unit Quantity</th>
                <th>Unit</th>
                <th>Kind & No. of Packages</th>

                <th>Net Weight(kg)</th>

                <th>Gross Weight(kg)</th>
                <th>Measurements(m³)</th>
              </tr>
            </thead>
            <tbody>
              {productDetails &&
                productDetails.map((itm, i) => {
                  return (
                    <tr key={i}>
                      <td>{itm.lineSrno}</td>
                      <td>{itm.itemId}</td>
                      <td>{itm.productName}</td>
                      <td>{itm.deliveryDispatchQuantity}</td>
                      <td>{itm.unitAbbreviation}</td>
                      <td>
                        {" "}
                        <input
                          type={"text"}
                          id={"noOfPackages"}
                          required
                          ref={(el) => (frmRef.current["noOfPackages"] = el)}
                          className="form-control"
                          defaultValue={productDetails[i].noOfPackages}
                          onChange={(e) => {
                            productDetails[i].noOfPackages = e.target.value;

                            setProductDetails([...productDetails]);
                          }}
                        />
                      </td>

                      <td>{itm.netWeight}</td>

                      <td>{itm.grossWeight}</td>
                      <td>
                        {" "}
                        <input
                          type={"text"}
                          id={"measurements"}
                          required
                          ref={(el) => (frmRef.current["measurements"] = el)}
                          className="form-control"
                          defaultValue={productDetails[i].measurements}
                          onChange={(e) => {
                            productDetails[i].measurements = e.target.value;

                            setProductDetails([...productDetails]);
                          }}
                        />
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </Modal>
      )}
    </>
  );
};

export default PackingListForm;
